import { z } from 'zod';

export const companyUrlSchema = z.object({
  company_domain: z.string().trim().min(1, 'Você precisa informar o url da empresa'),
});

export type CompanyUrlValidationSchema = z.infer<typeof companyUrlSchema>;
